<template>
  <div class="about-me">
    <center>
      <h3>About Me and the project:</h3>
      <p>I am a web and a blockchain developer.</p>
      <p>
        This is a simple implementation of the UniswapV2 contract
        functionalities in my own way. So enjoy using it!
      </p>
    </center>
  </div>
</template>

<style>
.about-me {
  padding-top: 4rem;
  margin-top: 6rem;
}
</style>
